export const popupEvents = ['open', 'close'];
